import {AElement} from "./AElement";
import {EElementType} from "../utils/EElementType";
import ModelsRegExp from "../../services/ModelsRegExp";

export class Unknown extends AElement {

    constructor(serialNumber: string, isScanned?: boolean) {
        super(EElementType.Unknown, serialNumber, isScanned, ModelsRegExp.elementUnknown);
    }

}
